import { LowerCasePipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
export type TPaymentIcon = 'mc' | 'amex' | 'visa' | 'maestro' | 'paypal' | 'apple' | 'googlepay';
@Component({
    selector: 'payment-icon',
    templateUrl: './payment-icon.html',
    styleUrls: ['payment-icon.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgClass, LowerCasePipe]
})
export class PaymentIconComponent {
    @Input()
    method?: string;
}
